import { createSelector } from 'reselect';
import { baseSelector } from './entities';

export const profileSelector = createSelector(baseSelector, (entities) =>
	entities?.profile
);

export const selectPhoneNumber = (state) => state?.entities?.profile?.phone_number;

export const selectSSN = (state) => state?.entities?.profile?.encrypted_social_security_number;
